import React from "react";
import Icon from "../Icon";
import { CircularProgress, IconButton, Tooltip } from "@mui/material";


/**
 * A simple button that shows an icon. The only prop it needs is 'icon', which should be the name of the icon to show.
 * It also takes an 'action' prop, which is the function to call when the button is clicked.
 *
 * @param {string} icon The name of the icon to show
 * @param {function} action The function to call when the button is clicked
 * @returns {React.Component} A button with the specified icon that will call the specified action when clicked.
 */
export default function IconButtonHT({ icon, action, disabled = false, style = {}, loading = false, color="black", toolTip="",className="" }) {

  if (loading) return <CircularProgress style={{width:"1em", height:"1em", margin:5}} />;
  let s = style
  if (color) {
    s.color = color
  }

  if(!toolTip)return (
    <IconButton
      onClick={action}
      disabled={disabled}
      style={s}
      className={className}
    >
      <Icon name={icon} />
    </IconButton>
  );

  return (
    <Tooltip title={toolTip}>
      <IconButton
        onClick={action}
        disabled={disabled}
        style={s}
        className={className}
      >
        <Icon name={icon} />
      </IconButton>
    </Tooltip>
  );
}